/**
 * Created by crisan on 7/12/16.
 */



class LicenseCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    
    private cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter;

    awakeFromHTML()
    {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        
        this.separatorStyle = UITableViewCellSeparatorStyle.None;
    }

    set item(i:BusinessLicense)
    {
        this.nameLabel.text = i.name;

        // Inactive wins over unlinked: a cancelled licence is red whatever its link state.
        // Unlinked = no auth business behind it yet (authSchema empty), shown in dark yellow
        // so the ones still waiting to be matched with a venue stand out in the list.
        let inactive = ( i.active == false );
        let unlinked = !inactive && ( i.authSchema == null || i.authSchema.length == 0 );

        if (inactive) MUICoreLayerAddStyle(this.nameLabel.layer, "alert");
        else MUICoreLayerRemoveStyle(this.nameLabel.layer, "alert");

        if (unlinked) MUICoreLayerAddStyle(this.nameLabel.layer, "unlinked");
        else MUICoreLayerRemoveStyle(this.nameLabel.layer, "unlinked");
    }

}